import { Link } from 'react-router-dom';
import { buttonVariants } from './Button.cva';

export interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  intent?: 'primary' | 'black' | 'white';
  size?: 'xs' | 'sm' | 'base';
  icon?: React.ReactNode;
  textAlign?: 'left' | 'center';
  href?: string;
  isExternal?: boolean;
}

export function Button({
  intent,
  size = 'base',
  icon,
  disabled = false,
  textAlign = 'left',
  href,
  isExternal,
  className,
  children,
  ...props
}: ButtonProps) {
  const buttonStyles = buttonVariants({
    intent,
    size,
    disabled,
    textAlign,
    className,
  });

  const content = (
    <>
      {icon}
      {children}
    </>
  );

  if (href) {
    return isExternal ? (
      <a className={buttonStyles} href={href} target="_blank" title={props.title} rel="noreferrer">
        {content}
      </a>
    ) : (
      <Link className={buttonStyles} to={href} title={props.title}>
        {content}
      </Link>
    );
  }

  return (
    <button className={buttonStyles} disabled={disabled} {...props}>
      {content}
    </button>
  );
}
